module.exports = __webpack_public_path__ + "img/88.2.TN.68c8c251.png";